import { render, staticRenderFns } from "./BaseNavDropdown.vue?vue&type=template&id=a364880a"
import script from "./BaseNavDropdown.vue?vue&type=script&lang=ts"
export * from "./BaseNavDropdown.vue?vue&type=script&lang=ts"
import style0 from "./BaseNavDropdown.vue?vue&type=style&index=0&id=a364880a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports